import React, { useState } from 'react';
import { TodoInput, TodoFormHeader } from '../../styles/TodoList.styles';

const TodoForm = ({ onAddTodo, placeholder }) => {
    const [newTodo, setNewTodo] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (newTodo.trim()) {
            onAddTodo(newTodo);
            setNewTodo('');
        }
    };

    return (
        <TodoFormHeader>
            <form onSubmit={handleSubmit}>
                <TodoInput
                    type="text"
                    value={newTodo}
                    onChange={(e) => setNewTodo(e.target.value)}
                    placeholder={placeholder}
                />
            </form>
        </TodoFormHeader>
    );
};

export default TodoForm;